import styled from '@emotion/styled'

export default styled.code`
  display: inline-block;
  background-color: #ebf3ff;
  padding: 0 6px;
  font-style: italic;
`
